<div class="mt-md-3 container-fluid">

  <div class="row mt-2">
    <div class="col-12 col-md-8 offset-md-2">
      <div class="row rmt-2">
        <div class="col-12 col-md-10 offset-md-1">
          <h5 class="text-secondary text-center mb-4">
            Etiquetas masivamente
          </h5>

          <ng-container *ngIf="_auth.hasPermission('credito.etiquetas.create')">
            <!-- Card de carga -->
            <div data-rbac-permiso="credito.etiquetas.create" class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-5 mb-4">
              <div (change)="reload_noti()">
                <mbsc-input [options]="mobileSettingsFile" (change)="onFileSelected($event)" type="file" placeholder="Select file...">Adjunte el soporte</mbsc-input>
              </div>

              <div class="text-xs text-red-600 dark:text-red-400 mt-1" *ngIf="!this.formDataUpload">
                <i class="fas fa-exclamation-circle mr-1"></i>El adjunto es obligatorio
              </div>

              <div class="mt-3">
                <button [disabled]="!formDataUpload"
                        (click)="submit()"
                        type="button"
                        class="w-100 inline-flex items-center justify-center px-4 py-2 text-sm font-semibold text-white bg-primary-600 hover:bg-primary-700 disabled:bg-gray-300 disabled:cursor-not-allowed rounded-md shadow-sm transition-colors">
                  <span *ngIf="!loadingXls"><i class="fas fa-upload mr-2"></i>Carga masiva de etiquetas</span>
                  <span *ngIf="loadingXls"><i class="fas fa-spinner fa-spin mr-2"></i>Cargando…</span>
                </button>
              </div>
            </div>
          </ng-container>

          <!-- Encabezado de procesos -->
          <div *ngIf="trace_documets?.length > 0" class="flex items-center justify-between mb-3 px-1">
            <h6 class="text-sm font-bold text-gray-700 dark:text-gray-300 m-0">
              <i class="fas fa-history mr-1.5 text-gray-500"></i>Procesos
              <span class="text-gray-400 font-normal">({{trace_documets.length}})</span>
            </h6>
            <button (click)="reload_noti()"
                    class="flex items-center justify-center w-8 h-8 text-xs text-gray-500 rounded-md hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 transition-colors"
                    title="Refrescar lista">
              <i class="fas fa-sync-alt"></i>
            </button>
          </div>

          <!-- Lista de cards modernas -->
          <div *ngFor="let item of trace_documets"
               class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow transition-all duration-150 border-l-4 mb-3"
               [ngClass]="{
                 'border-l-green-500': item?.state == 'COMPLETE',
                 'border-l-yellow-500': item?.state == 'PENDING',
                 'border-l-red-500': item?.state == 'ERROR',
                 'border-l-gray-400': item?.state == 'CANCELED'
               }">

            <!-- Header: badge + título + acción -->
            <div class="px-5 py-3 flex items-start justify-between gap-3 border-b border-gray-100 dark:border-gray-700">
              <div class="flex-1 min-w-0">
                <div class="flex items-center gap-2 mb-1">
                  <span class="inline-flex items-center text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded" [ngClass]="{
                    'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400': item?.state == 'COMPLETE',
                    'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400': item?.state == 'PENDING',
                    'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400': item?.state == 'ERROR',
                    'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300': item?.state == 'CANCELED'
                  }">
                    <span class="w-1.5 h-1.5 rounded-full mr-1" [ngClass]="{
                      'bg-green-500': item?.state == 'COMPLETE',
                      'bg-yellow-500 animate-pulse': item?.state == 'PENDING',
                      'bg-red-500': item?.state == 'ERROR',
                      'bg-gray-400': item?.state == 'CANCELED'
                    }"></span>
                    <span *ngIf="item?.state == 'COMPLETE'">Completado</span>
                    <span *ngIf="item?.state == 'PENDING'">En curso</span>
                    <span *ngIf="item?.state == 'ERROR'">Error</span>
                    <span *ngIf="item?.state == 'CANCELED'">Cancelado</span>
                  </span>
                </div>
                <h3 class="text-base font-bold text-gray-900 dark:text-gray-100 truncate">
                  Carga masiva de etiquetas
                </h3>
              </div>

              <!-- Acción primaria -->
              <div class="flex-shrink-0 flex items-center gap-2">
                <button *ngIf="item?.state == 'COMPLETE' && item?.url"
                        (click)="dowloader_document(item?.url)"
                        class="inline-flex items-center px-3.5 py-1.5 text-xs font-semibold text-white bg-primary-600 hover:bg-primary-700 rounded-md shadow-sm transition-colors">
                  <i class="fas fa-download mr-1.5"></i>Descargar resultado
                </button>
                <!-- Botón Detener (solo PENDING + no canceled aún) -->
                <button *ngIf="item?.state == 'PENDING' && !item?.cancel_requested"
                        (click)="cancelTrace(item)"
                        class="inline-flex items-center px-3 py-1.5 text-xs font-medium text-red-700 dark:text-red-300 bg-white dark:bg-transparent border border-red-300 dark:border-red-700 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-md transition-colors"
                        title="Detener esta carga (pedirá razón)">
                  <i class="fas fa-stop-circle mr-1.5"></i>Detener
                </button>
                <!-- Indicador mientras el worker procesa el cancel -->
                <span *ngIf="item?.cancel_requested && item?.state == 'PENDING'"
                      class="inline-flex items-center px-3 py-1.5 text-xs italic text-orange-700 dark:text-orange-300 bg-orange-50 dark:bg-orange-900/20 rounded-md">
                  <i class="fas fa-hourglass-half mr-1.5"></i>Cancelando…
                </span>
              </div>
            </div>

            <!-- Metadata grid: ejecutor + duración + inicio + fin -->
            <div class="px-5 py-3 grid grid-cols-2 gap-3 text-sm">
              <div>
                <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-0.5">
                  <i class="fas fa-user-circle mr-1"></i>Ejecutado por
                </div>
                <div class="font-medium text-gray-900 dark:text-gray-100 truncate" *ngIf="item?.executed_by">{{ item.executed_by }}</div>
                <div class="italic text-gray-400 text-xs" *ngIf="!item?.executed_by">— sin registro</div>
              </div>
              <div>
                <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-0.5">
                  <i class="fas fa-stopwatch mr-1"></i>Duración
                </div>
                <div class="font-mono font-medium text-gray-900 dark:text-gray-100" *ngIf="item?.state == 'COMPLETE' && item?.date_end">
                  {{ getDurationHuman(item?.date_start, item?.date_end) }}
                </div>
                <div *ngIf="item?.state == 'PENDING'">
                  <div class="font-mono text-blue-600 dark:text-blue-400">
                    {{ getElapsedHuman(item?.date_start) }} <span class="text-[10px] text-gray-400">transcurridos</span>
                  </div>
                  <div *ngIf="item?.time_aprox" class="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">
                    <i class="fas fa-history mr-0.5"></i>~{{item?.time_aprox}} aprox.
                  </div>
                </div>
                <div class="italic text-gray-400 text-xs" *ngIf="item?.state == 'ERROR' || item?.state == 'CANCELED'">—</div>
              </div>
              <div>
                <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-0.5">
                  <i class="fas fa-play-circle mr-1 text-green-500"></i>Inicio
                </div>
                <div class="font-mono text-xs text-gray-800 dark:text-gray-200">{{ item?.date_start | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
              </div>
              <div>
                <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-0.5">
                  <i class="fas fa-flag-checkered mr-1 text-blue-500"></i>Fin
                </div>
                <div class="font-mono text-xs text-gray-800 dark:text-gray-200" *ngIf="item?.date_end">{{ item?.date_end | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
                <div class="italic text-gray-400 text-xs" *ngIf="!item?.date_end && item?.state == 'PENDING'">en curso…</div>
                <div class="italic text-gray-400 text-xs" *ngIf="!item?.date_end && item?.state != 'PENDING'">—</div>
              </div>
            </div>

            <!-- Barra de progreso (solo si PENDING con progress definido) -->
            <div *ngIf="item?.state == 'PENDING' && (item?.progress?.percentage != null || item?.progress?.current_phase_description)"
                 class="px-5 pb-3 pt-1 border-t border-gray-100 dark:border-gray-700">
              <div class="flex items-center justify-between mb-1.5 text-xs">
                <span class="font-medium text-blue-700 dark:text-blue-300">
                  <i class="fas fa-spinner fa-spin mr-1"></i>
                  {{ item?.progress?.current_phase_description || item?.progress?.current_phase || 'Procesando' }}
                </span>
                <span class="font-mono font-bold text-blue-900 dark:text-blue-200">{{ item?.progress?.percentage || 0 }}%</span>
              </div>
              <div class="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden mb-2">
                <div class="h-full bg-blue-500 dark:bg-blue-400 transition-all duration-500"
                     [style.width.%]="item?.progress?.percentage || 0"></div>
              </div>
              <div *ngIf="item?.progress?.processed != null || item?.progress?.total > 0" class="text-xs text-gray-600 dark:text-gray-400">
                <span class="text-gray-500">Procesado:</span>
                <span class="font-medium ml-1">{{ (item?.progress?.processed || 0) | number }}<span *ngIf="item?.progress?.total"> / {{ item?.progress?.total | number }}</span></span>
                <span class="ml-2 text-gray-400">registros</span>
              </div>
            </div>

            <!-- Mensaje de error -->
            <div *ngIf="item?.state == 'ERROR' && item?.description"
                 class="px-5 py-2.5 border-t border-red-100 dark:border-red-900/30 bg-red-50/50 dark:bg-red-900/10">
              <div class="flex items-start gap-2 text-xs text-red-700 dark:text-red-400">
                <i class="fas fa-exclamation-triangle mt-0.5"></i>
                <span>{{ item?.description }}</span>
              </div>
            </div>

            <!-- Mensaje cancelado -->
            <div *ngIf="item?.state == 'CANCELED' && (item?.description || item?.canceled_by)"
                 class="px-5 py-2.5 border-t border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50">
              <div class="flex items-start gap-2 text-xs text-gray-600 dark:text-gray-400">
                <i class="fas fa-info-circle mt-0.5"></i>
                <div class="flex-1">
                  <div *ngIf="item?.description">{{ item?.description }}</div>
                  <div *ngIf="item?.canceled_by" class="text-[10px] text-gray-500 mt-0.5">
                    <i class="fas fa-user mr-0.5"></i>Cancelado por <span class="font-medium">{{ item.canceled_by }}</span>
                    <span *ngIf="item?.canceled_at"> · {{ item.canceled_at | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>
